<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Communiquer à l'oral dans le monde professionnel" index-progression-courante="3"
                   index-progression-secondaire="1"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="communiquerecrit"/>
    <footer-applis ecran-precedent="competencestransversales" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'communiqueroral',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    FooterApplis,
    HeaderApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'Je communique très partiellement en situation d\'entretien de face à face'
      }, {
        niveau: 2,
        valeur: 'Je communique avec des acteurs de l\'emploi et de la formation sur mon projet et mon parcours'
      }, {
        niveau: 3,
        valeur: 'Je communique en face à face, au téléphone et peux expliquer des choix'
      }, {
        niveau: 4,
        valeur: 'J\'adapte ma manière de communiquer à tout interlocuteur et dans toute situation liée à l\'emploi'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.communiqueroral = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('communiquerecrit');
    }
  }
}
</script>
